export default (state, text) => ({
  action: 'Typing',
  text,
  operator_session_id:
    state.currentOperator.operator_session_id,
})
